/**
 * @name ActivityController
 * @description Controller for activity
 * @param {type} $timeout Description
 * @param {type} Messages Description
 * @param {type} Activity Description
 * @param {type} _ Description
 * @param {type} $rootScope Angular rootScope service
 * @param {type} $scope Angular scope service
 * @param {service} Session The session service
 * @param {service} $log Angular log service
 * @param {service} Participants The Participants service
 * @param {service} $q Angular $q service
 * @param {service} moment The moment library
 */
function ActivityController(
  $timeout,
  Messages,
  Activity,
  _,
  $rootScope,
  $scope,
  Session,
  $log,
  Participants,
  $q,
  moment
) {
  let vm = this;

  vm.$onInit = function() {
    vm.messages = [];
    vm.apptActivity = [];
    vm.projectActivity = [];
    vm.mergedData = [];
    vm.session = Session;
    vm.markAsRead = markAsRead;
    vm.hasMessages = _.isUndefined(vm.hasMessages) ? true : vm.hasMessages;
    vm.hasAppointmentActivity = _.isUndefined(vm.hasAppointmentActivity) ?
    true : vm.hasAppointmentActivity;
    vm.hasProjectActivity = _.isUndefined(vm.hasProjectActivity) ?
    true : vm.hasProjectActivity;
  };

  vm.$onChanges = function(changes) {
    if (changes.conversationId &&
    !_.isUndefined(changes.conversationId.currentValue)) {
      get(changes.conversationId.currentValue);
    }
    if (changes.projectId &&
    !_.isUndefined(changes.projectId.currentValue)) {
      getActivity('project', changes.projectId.currentValue);
    }
    if (changes.appointmentId &&
    !_.isUndefined(changes.appointmentId.currentValue)) {
      getActivity('appointment', changes.appointmentId.currentValue);
    }
  };

  // Merge activity when updating activity or message arrays
  let deregister = $scope.$on('merge-activity',
  function(event, conversationId, appointmentId, projectId) {
    if (!_.isUndefined(conversationId)) {
      get(conversationId);
    }
    if (!_.isUndefined(projectId)) {
      getActivity('project', projectId);
    }
    if (!_.isUndefined(appointmentId)) {
      getActivity('appointment', appointmentId);
    }
  });
  $scope.$on('$destroy', deregister);

  /**
   * @name get
   * @description Function to get conversations for an appointment by ID
   * @param {number} conversationId The ID of the conversation to retrieve
   */
  function get(conversationId) {
    let appointmentId;
    let collectorId = Session.collector.id;
    Messages.get(conversationId, appointmentId, collectorId)
    .then(function(messages) {
      vm.messages = messages;
      vm.mergedData =
      _.concat(vm.messages, vm.apptActivity, vm.projectActivity);
      Participants.get(conversationId, appointmentId, collectorId)
      .then(function(participant) {
        if (participant.length) {
          vm.lastReadDate =
          moment(participant[0].last_read_date).format('YYYY-MM-DDTHH:mm:ss');
        }
      });
    });
  }

  /**
   * @name getActivity
   * @description Function to get activity for appointments and projects
   * @param {type} contentType The type of content activity. Options are
   * 'appointment' and 'project'
   * @param {type} objectId The ID of the object to get
   */
  function getActivity(contentType, objectId) {
    Activity.get(contentType, objectId).then(function(activity) {
      if (contentType === 'project') {
        vm.projectActivity = activity;
      } else if (contentType === 'appointment') {
        vm.apptActivity = activity;
      }
      vm.mergedData =
      _.concat(vm.messages, vm.apptActivity, vm.projectActivity);
    });
  }

  /**
   * @name markAsRead
   * @description Function to update the last read date for the user's
   * participant
   * @param {type} conversationId The ID of the conversation
   */
  function markAsRead(conversationId) {
    let appointmentId;
    let collectorId = Session.collector.id;
    Participants.get(conversationId, appointmentId, collectorId)
    .then(function(participant) {
      if (participant.length) {
        let participantToUpdate = participant[0];
        participantToUpdate.last_read_date =
        moment.utc().format('YYYY-MM-DDTHH:mm:ss');
        Participants.update(participantToUpdate)
        .then(function(updatedParticipant) {
          vm.lastReadDate = updatedParticipant.last_read_date;
        });
      }
    });
  }
}

angular
  .module('inkfinder')
  .controller('ActivityController', ActivityController);



// WEBPACK FOOTER //
// ./components/activity/activity.controller.js